import store from '@/newApplication/store';

function getError() {
  store.dispatch(
    'notifications/setNotification',
    {
      notificationStatus: 'error',
      notificationMessage: 'Ошибка получения данных ',
      timeout: 3000,
    },
    { root: true },
  );
}
export default getError;
